import { FC } from 'react';
import { TooltipProps } from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

type CustomTooltipProps = TooltipProps<ValueType, NameType>;

export const CustomTooltip: FC<CustomTooltipProps> = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white px-12 py-8 border border-gray-300 rounded-[8px] shadow-md">
        {payload.map((item, index) => (
          <p key={index} className="text-r12 text-black-0">
            ${item.value}
          </p>
        ))}
      </div>
    );
  }

  return null;
};
